import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as CommunityContextConsumer } from '../../../contexts/CommunityContext';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import CommunityFeeds, {
    LOAD_MORE_BUTTON,
    NO_BUTTON,
    REDIRECT_TO_FEED,
} from './CommunityFeeds/CommunityFeeds';

export default class Feed extends React.PureComponent {
    renderFeed() {
        const { feedType, location } = this.props;
        return (
            <PageConsumer>
                {(pageContext) => (
                    <CommunityContextConsumer>
                        {(context) => {
                            return (
                                <CommunityFeeds
                                    infiniteScroll={this.props.infiniteScroll}
                                    topics={this.props.topics}
                                    communityGroupHash={
                                        this.props.communityGroupHash
                                    }
                                    fetchMoreContent={context.fetchMoreContent}
                                    hasNext={context.hasNext}
                                    feedLastResultCount={
                                        context.feedLastResultCount
                                    }
                                    content={context.content}
                                    feedGroup={this.props.feedGroup}
                                    feedGroupId={this.props.feedGroupId}
                                    feedType={feedType}
                                    location={location}
                                    useCommonCardShell={
                                        this.props.useCommonCardShell
                                    }
                                    featureFlags={
                                        pageContext.pageProps.featureFlags
                                    }
                                    loadMoreButtonText={
                                        this.props.loadMoreButtonText
                                    }
                                    createContentEnabled={
                                        this.props.createContentEnabled
                                    }
                                    endOfFeedButtonType={
                                        this.props.endOfFeedButtonType
                                    }
                                    hideReactionBar={this.props.hideReactionBar}
                                    topicLoadMoreObject={
                                        this.props.topicLoadMoreObject
                                    }
                                    topicMetrics={this.props.topicMetrics}
                                    topicContentTotal={
                                        this.props.topicContentTotal
                                    }
                                    userRelation={this.props.userRelation}
                                />
                            );
                        }}
                    </CommunityContextConsumer>
                )}
            </PageConsumer>
        );
    }

    render() {
        return (
            <div className="component-Content-Feed">{this.renderFeed()}</div>
        );
    }
}

Feed.propTypes = {
    /**
     *  feed type
     */
    feedType: PropTypes.oneOf(['miniFeed', 'masterFeed']).isRequired,
    /**
     *  type of feed
     */
    feedGroup: PropTypes.oneOf([
        'CommunityDiscussion',
        'CommunityLink',
        'CommunityTopic',
        'CommunityTag',
        'EditorialContent',
        'GlobalFeed',
        'Company',
        'GroupFeed',
    ]).isRequired,
    /**
     * feed id
     */
    feedGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /**
     * the location of the feed (for metrics purposes)
     */
    location: PropTypes.oneOf(['masterFeed', 'groupFeed', 'topic-load-more']),
    /**
     * group hash required when fetching a group feed
     */
    communityGroupHash: PropTypes.string,
    /**
     * topics array
     */
    topics: PropTypes.shape({
        id: PropTypes.number,
        isDefault: PropTypes.number,
        layout: PropTypes.string,
        qaDataAttr: PropTypes.string,
        sponsored: PropTypes.shape({
            alt: PropTypes.string,
            src: PropTypes.string,
            url: PropTypes.string,
        }),
        title: PropTypes.string,
        total: PropTypes.number,
        url: PropTypes.string,
    }),
    /**
     * whether or not you can create content
     */
    createContentEnabled: PropTypes.bool,
    /**
     * text for button
     */
    loadMoreButtonText: PropTypes.string,
    /**
     * if true then load more content button, if false then redirect button
     */
    endOfFeedButtonType: PropTypes.oneOf([
        LOAD_MORE_BUTTON,
        REDIRECT_TO_FEED,
        NO_BUTTON,
    ]),
    infiniteScroll: PropTypes.bool,
    hideReactionBar: PropTypes.bool,
    topicLoadMoreObject: PropTypes.shape({ topicUrl: PropTypes.string }),
    topicMetrics: PropTypes.shape({
        misc_event_type: PropTypes.string,
        misc_event_count: PropTypes.number,
    }),
    topicContentTotal: PropTypes.number,
    userRelation: PropTypes.shape({
        role: PropTypes.string,
    }),
    useCommonCardShell: PropTypes.bool,
};

Feed.defaultProps = {
    feedGroupId: 'master',
    loadMoreButtonText: 'Load more',
    hideReactionBar: false,
    userRelation: {},
    location: 'master',
    communityGroupHash: '',
    createContentEnabled: false,
    infiniteScroll: true,
    topicLoadMoreObject: {
        topicUrl: '',
    },
    topicContentTotal: 0,
    topicMetrics: {
        misc_event_type: '',
        misc_event_count: 0,
    },
    endOfFeedButtonType: NO_BUTTON,
    topics: [],
    useCommonCardShell: false,
};
